import { ReportStatus } from '@/generated/enums'
import { useIsEmployee } from '@/hooks/id_token_claims'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import {
  createQueueMovementKey,
  QUEUE_MOVEMENTS_TO_VALID_REASONS,
  QUEUES_TO_MONITOR_BETWEEN,
} from '@/components/queue_movement_feedback/queue_movements_constants'
import { ReportType } from '@/utils/constants'

function useIsLateralMovementsSurveyEnabled(
  oldReportStatus: ReportStatus,
  reportType: ReportType,
): [isSurveyEnabled: boolean] {
  const isFeatureFlagEnabled = useFeatureFlagEnabled('queue-movement-feedback')
  const isEmployee = useIsEmployee()
  const isDomains = reportType === ReportType.DOMAINS

  if (!(isFeatureFlagEnabled && isEmployee && isDomains && oldReportStatus)) {
    return [false]
  }

  return [true]
}

function isQueueMovementLateral(
  oldReportStatus: ReportStatus,
  newReportStatus: ReportStatus,
) {
  const isLateralQueueMovement =
    QUEUES_TO_MONITOR_BETWEEN.includes(oldReportStatus) &&
    QUEUES_TO_MONITOR_BETWEEN.includes(newReportStatus)
  const queueMovementIsInTable = QUEUE_MOVEMENTS_TO_VALID_REASONS.has(
    createQueueMovementKey(oldReportStatus, newReportStatus),
  )
  const differentReportStatus = oldReportStatus !== newReportStatus

  return (isLateralQueueMovement || queueMovementIsInTable) && differentReportStatus
}

export { useIsLateralMovementsSurveyEnabled, isQueueMovementLateral }
